import { render } from "./AppConfigPage.vue?vue&type=template&id=0a740802&scoped=true&ts=true"
import script from "./AppConfigPage.vue?vue&type=script&lang=ts"
export * from "./AppConfigPage.vue?vue&type=script&lang=ts"

import "./AppConfigPage.vue?vue&type=style&index=0&id=0a740802&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a740802"]])

export default __exports__